import { useMemo } from "react";
import type { ListboxSectionProps } from "./types";
import clsx from "clsx";

// 自定义 ListboxSection 组件
export const ListboxSection: React.FC<ListboxSectionProps> = ({
    children,
    title,
    showDivider,
    className,
    classNames,
    ...props
}) => {
    // 基础样式类
    const baseClasses = useMemo(() => clsx(
        "w-full",
        classNames?.base,
        className
    ), [classNames?.base, className]);

    // 标题样式类
    const headingClasses = useMemo(() => clsx(
        "px-3 py-2 text-xs font-semibold text-default-600 uppercase tracking-wider",
        classNames?.heading
    ), [classNames?.heading]);

    // 组样式类
    const groupClasses = useMemo(() => clsx(
        "flex flex-col gap-1",
        classNames?.group
    ), [classNames?.group]);

    // 分隔线样式类
    const dividerClasses = useMemo(() => clsx(
        "border-default-200 mx-3 my-2",
        classNames?.divider
    ), [classNames?.divider]);

    return (
        <div className={baseClasses} {...props}>
            {title && (
                <div className={headingClasses} role="presentation">
                    {title}
                </div>
            )}

            <div className={groupClasses} role="group" aria-label={title}>
                {children}
            </div>

            {showDivider && (
                <hr className={dividerClasses} />
            )}
        </div>
    );
};

ListboxSection.displayName = "ListboxSection";